import React, {ReactNode} from "react";
import FfairModal from "view/components/modal/FfairModal";
import FfairPaper from "view/components/FfairPaper";
import {makeStyles} from "@material-ui/core/styles";
import {Button, Typography} from "@material-ui/core";
import Alert from "view/components/Alert";
import {Actions} from "view/components/Form";

type Props = {
  onClose: () => void;
  onSubmit: () => Promise<void>;
  warnings: ReactNode[];
};
const ConfirmationModal = ({onClose, onSubmit, warnings}: Props) => {
  const classes = useStyles();

  return (
    <FfairModal open onClose={onClose} isCalledByAnotherModal>
      <FfairPaper className={classes.root}>
        <Typography variant="h2" style={{fontWeight: 500}}>
          Pop-up
        </Typography>
        {warnings.map((warning, idx) => (
          <Alert fullWidth severity="warning" key={idx}>
            {warning}
          </Alert>
        ))}
        <Actions style={{paddingTop: 0}}>
          <Button onClick={onClose} color="primary">
            Cancel
          </Button>
          <Button onClick={onSubmit} color="primary">
            Submit
          </Button>
        </Actions>
      </FfairPaper>
    </FfairModal>
  );
};

const useStyles = makeStyles(({spacing}) => ({
  root: {
    width: 540,
    padding: spacing(3),
    display: "flex",
    flexDirection: "column",
    gap: spacing(2),
  },
}));
export default ConfirmationModal;
